import { apiUrl } from '@configs/environment';
import httpClient from '@shared/api/httpClient';
import httpNodeClient from '@shared/api/httpNodeClient';

export const fetchAllLocationsData = (): Promise<string[]> =>
  httpClient.get(`${apiUrl}/locations/countries/`).then((resp) => resp.data.data);

/**
 * Fetches legal countries data from the metro-areas API endpoint.
 * This endpoint provides countries where employees are legally registered to work,
 * as opposed to their current physical locations.
 * @returns Promise resolving to an array of legal country names
 */
export const fetchLegalCountriesData = (): Promise<string[]> =>
  httpNodeClient.get('/metro-areas/countries').then((resp) => resp.data);
